import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 2rem;
`;

const Logo = styled.img`
  width: 150px;
  height: auto;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: #1877f2;
  margin-bottom: 1rem;
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  color: #65676b;
  margin-bottom: 2rem;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const Button = styled(Link)`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: bold;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`;

const LoginButton = styled(Button)`
  background-color: #1877f2;
  color: white;
`;

const RegisterButton = styled(Button)`
  background-color: #42b72a;
  color: white;
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const FeatureIcon = styled.span`
  font-size: 1.5rem;
  margin-right: 0.5rem;
`;

const FeatureText = styled.p`
  font-size: 1rem;
  color: #65676b;
`;

const LandingPage = () => {
  return (
    <Container>
      <Logo src="/rextifire.jpg" alt="Rextifire Logo" />
      <Title>AI Chat Application</Title>
      <Subtitle>Experience the future of communication with our AI-powered chat</Subtitle>
      
      <ButtonContainer>
        <LoginButton to="/login">Log In</LoginButton>
        <RegisterButton to="/register">Sign Up</RegisterButton>
      </ButtonContainer>
      
      <div style={{ marginTop: '3rem' }}>
        <Feature>
          <FeatureIcon>🤖</FeatureIcon>
          <FeatureText>Advanced AI-powered conversations</FeatureText>
        </Feature>
        <Feature>
          <FeatureIcon>🔒</FeatureIcon>
          <FeatureText>Secure and private messaging</FeatureText>
        </Feature>
        <Feature>
          <FeatureIcon>📱</FeatureIcon>
          <FeatureText>Seamless experience across devices</FeatureText>
        </Feature>
      </div>
    </Container>
  );
};

export default LandingPage;